import type { FaireProductEntity } from "../../entity_types/product";

export const p_6rm9cthdfr: FaireProductEntity = {
  token: "p_6rm9cthdfr",
  type: "product",
  name: "Natural Rose Quartz Tumble Loose Stone Chips",
  brandToken: "b_t9ve76j393",
  brandName: "CaNatureLover",
  imageUrl:
    "https://cdn.faire.com/fastly/4b2afa33b14ddba7393ee2c087ab5f571c431009ed4759d3f53b6d3eb3a4ed04.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7329bf44e31dc9ce9e5ccb58db4b7c1088dd3ca22171f42b0857de20f951ef74.jpeg",
    "https://cdn.faire.com/fastly/b3e91e9956a407a853305c9b19374c6fadb514a2033e54821c6e4b3f4234f69c.jpeg",
    "https://cdn.faire.com/fastly/bb8c9406683554b13ed9585430907e0a6c80acf23b46b5e316ff93c0207d7709.jpeg",
    "https://cdn.faire.com/fastly/ea2f3e75d2ed6c3747f7a6d3ba98a4e34a9e11e00e8708a8848edf0b170ccc1f.jpeg",
    "https://cdn.faire.com/fastly/553dcc18ed07e54363cd854b2a6308605c0a8a661c9cc1d67af94bf943d6c68d.jpeg",
    "https://cdn.faire.com/fastly/69b782e0e48d4c40868d2244817e5b9148f4540b0996f322862e847a2bfbaacc.jpeg",
    "https://cdn.faire.com/fastly/2d92f4a90746603d6e8b571ca205c6aea3efcd84dae6fdc24c63e427a9f4e3a8.jpeg",
    "https://cdn.faire.com/fastly/cdfbc18156f80c69b237d29a11989683d82c3daa71ffd574474dc9d8ba76ba92.jpeg",
    "https://cdn.faire.com/fastly/b6ab53d44cdcbe7fc585968aafa72f04c90086f717e37ef830605a7f773a30ab.jpeg",
  ],
  priceDollars: 1.99,
  description:
    "\nITEM DETAILS -\n\nsizes may vary because its natural gemstones made by nature sizes are around 0.25-0.50 inches (5-8 mm)\n\nRose Quartz is a member of the Quartz family. It usually occurs in massive form but sometimes grows in clusters of small prismatic crystals. Its name is derived from its colour, which ranges from very pale pink to deep reddish pink. Its clarity can range from opaque to translucent to transparent, although most transparent pieces are rather foggy.\n\n~ Healing ~\n Friendship\n Platonic love\n LOVE\n\nRose Quartz is the stone of universal love. It restores trust and harmony in relationships, encouraging unconditional love.",
  tags: [],
  msrpDollars: 3.98,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T19:26:06.316Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
